<topmenu></topmenu>

<mat-sidenav-container #sidenav open class="sidebar-container">
    <mat-sidenav #drawer opened="true" mode="side" position="start" role="navigation">
        <sidenav></sidenav>
    </mat-sidenav>
    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>